import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

import CustomInput from "../../components/form/CustomInput";
import CustomButton from "../../components/form/CustomButton";
import { resetConfirm, validaToken } from "../../helpers/configRoutes/backend_helper";

const AsignPassword = () => {
    const navigate = useNavigate();
    const { token } = useParams();
    const [loading, setLoading] = useState(false);
    const [tokenValid, setTokenValid] = useState(false);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: "",
            password: "",
            passwordConfirm: "",
            tokenSms: "",
            token
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email("Invalid email")
                .required("Email is required"),
            password: Yup.string()
                .min(8, "Minimum 8 characters")
                .matches(/[A-Z]/, "At least one uppercase letter")
                .matches(/[a-z]/, "At least one lowercase letter")
                .matches(/[0-9]/, "At least one number")
                .required("Password is required"),
            passwordConfirm: Yup.string()
                .oneOf([Yup.ref("password")], "Passwords do not match")
                .required("Confirm your password"),
            tokenSms: Yup.string()
                .required("Security code is required")
        }),
        onSubmit: async (values, { setErrors }) => {
            setLoading(true);

            const response = await resetConfirm(values);

            if (response.status) {
                navigate("/login");
            } else {
                if (response.errors) {
                    setErrors(response.errors);
                }
            }

            setLoading(false);
        }
    });

    useEffect(() => {
        const validateToken = async () => {
            const response = await validaToken({ token });

            if (!response.status) {
                navigate("/login");
                return;
            }

            validation.setFieldValue("email", response.email);
            setTokenValid(true);
        };

        validateToken();
    }, [token]);

    if (!tokenValid) {
        return null; // o loader
    }

    return (
        <div className="flex justify-center items-center w-screen h-screen bg-mts-blue-primary relative">
            <div className="flex flex-col w-full max-w-md bg-white rounded-[30px] shadow-md pt-[90px] pb-[90px] px-[40px] z-10">
                <div className="text-center text-xl text-gray-800 mb-6">
                    <p>Set your password</p>
                    <p className="text-base mt-4">
                        Please enter your new password
                    </p>
                </div>

                <form
                    className="flex flex-col space-y-4"
                    onSubmit={validation.handleSubmit}
                >
                    <CustomInput
                        label="Email Address"
                        type="email"
                        name="email"
                        value={validation.values.email}
                        error={validation.errors.email}
                        handleChange={validation.handleChange}
                        disabled
                    />

                    <div className="flex space-x-4">
                        <CustomInput
                            label="Password"
                            type="password"
                            name="password"
                            value={validation.values.password}
                            error={validation.errors.password}
                            handleChange={validation.handleChange}
                        />

                        <CustomInput
                            label="Confirm Password"
                            type="password"
                            name="passwordConfirm"
                            value={validation.values.passwordConfirm}
                            error={validation.errors.passwordConfirm}
                            handleChange={validation.handleChange}
                        />
                    </div>

                    <CustomInput
                        label="Security number (SMS code)"
                        name="tokenSms"
                        value={validation.values.tokenSms}
                        error={validation.errors.tokenSms}
                        handleChange={validation.handleChange}
                    />

                    <CustomButton
                        loading={loading}
                        textLoad="Processing"
                        className="w-full"
                    >
                        Send
                    </CustomButton>

                    <p className="text-center text-sm">
                        <span
                            className="text-blue-600 cursor-pointer hover:underline"
                            onClick={() => navigate("/login")}
                        >
                            Go back
                        </span>
                    </p>
                </form>
            </div>
        </div>
    );
};

export default AsignPassword;
